import React from 'react'

export const BingoBoardChoosePage = () => {
    return (
        <div style={{ margin: 5, padding: 5 }}>
            <h1>Choose a bingo above!</h1>
        </div>
    )
}
